import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { getMostPreferredCategory } from '@/pages/Onboarding/utils/getMostPreferredCategory';
import { getMostPrefferedInterest } from '@/pages/Onboarding/utils/getMostPrefferedInterest';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import {
  ReplikaChatVibeChatStyles,
  ReplikaChatVibePhoneStyles,
  ReplikaChatVibeStyles,
} from './ChatVibe.styles';

export const OnboardingReplikaChatVibe: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Chat Vibe',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  const { watch, getValues } = useFormContext<LayoutDataType>();
  const interests = watch('interests');
  const categories = watch('categories');
  const name = getValues('name');

  const mostPreferredInterest = getMostPrefferedInterest(interests);
  const mostPreferredCategory = getMostPreferredCategory(categories);

  return (
    <ReplikaChatVibeStyles>
      <OnboardingTitle color="black">
        I know exactly what you, {name}, want!
      </OnboardingTitle>
      <OnboardingSubtitle
        color="neutral-black"
        className="onboarding-no-limits__subtitle"
      >
        All AI characters share your interests and are genuinely involved in
        getting to know you!
      </OnboardingSubtitle>
      <IonContent>
        <div className="local-image-container">
          <ReplikaChatVibePhoneStyles>
            <img
              src={`https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/${mostPreferredCategory.key}/phone-chat.png`}
              alt="phone"
              onError={(e) => {
                e.currentTarget.src =
                  'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/phone-chat.png';
              }}
            />
          </ReplikaChatVibePhoneStyles>
          <ReplikaChatVibeChatStyles>
            <img
              src={`https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/chat-by-interest/${mostPreferredInterest}.png`}
              alt="chat"
              onError={(e) => {
                e.currentTarget.src =
                  'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/chat-by-interest/romantic.png';
              }}
            />
          </ReplikaChatVibeChatStyles>
        </div>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </ReplikaChatVibeStyles>
  );
};
